module.exports = __webpack_public_path__ + "static/media/walk_disabled_person_important.e8741816.svg";